var youtube = document.querySelectorAll('.youtube');

youtube.forEach(function (item) {
    var source = 'https://img.youtube.com/vi/' + item.dataset.embed + '/sddefault.jpg';
    var image = new Image();

    image.src = source;
    image.classList.add('img-fluid');
    image.addEventListener('load', function () {
        item.appendChild(image);
    }(item));

    item.addEventListener('click', function () {

        var iframe = document.createElement('iframe');

        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('src', 'https://www.youtube-nocookie.com/embed/' + this.dataset.embed + '?rel=0&showinfo=0&autoplay=1');

        this.innerHTML = '';
        this.appendChild(iframe);
    });
});



